/* eslint-disable */
export default {
  getUrlKey: function (name) {
    try {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [''])[1].replace(/\+/g, '%20')) || null
    }catch(err) {

    }
    return null
  },
  validateId: function (source) {
    let tab = 'ABCDEFGHJKLMNPQRSTUVXYWZIO'
    let A1 = [ 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3 ]
    let A2 = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5 ]
    let Mx = [ 9, 8, 7, 6, 5, 4, 3, 2, 1, 1 ]

    let pattern = /^[a-zA-Z][1-2][0-9]{8}$/
    if (!pattern.test(source)) return false
    source = source.toUpperCase()
    let first = tab.indexOf(source.charAt(0))
    if (first === -1) return false
    let sum = A1[first] + A2[first] * 9
    for (let i = 1; i < 10; i++) {
      let v = parseInt(source.charAt(i))
      if (isNaN(v)) return false
      sum = sum + v * Mx[i]
    }

    if (sum % 10 !== 0) return false
    return true
  },
  // url 組成
  buildUrl(url, obj) {
    const params = []
  
    Object.keys(obj).forEach((key) => {
      let value = obj[key]
      // 如果值为undefined我们将其置空
      if (typeof value === 'undefined') {
        value = ''
      }
      // 对于需要编码的文本（比如说中文）我们要进行编码
      params.push([key, encodeURIComponent(value)].join('='))
    })
  
    return url + '?' +params.join('&')
  }
}

